/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, limit: NonNullable<unknown>, date: NonNullable<unknown> }} Agent_Plugin_CreditsInputs */



/**
* | output |
* | --- |
* | "{used} of {limit} credits used this period (resets {date})" |
*
* @param {Agent_Plugin_CreditsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const agent_plugin_credits = /** @type {((inputs: Agent_Plugin_CreditsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Plugin_CreditsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.used} sur ${i?.limit} crédits utilisés durant cette période (réinitialise ${i?.date})`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.used} von ${i?.limit} Guthaben wurden in diesem Zeitraum verwendet (setzt ${i?.date} zurück)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.used} dei ${i?.limit} crediti utilizzati in questo periodo (reimposta ${i?.date})`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.used} из ${i?.limit} кредитов, использованных в этом периоде (обнуляет ${i?.date})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.used} de los créditos ${i?.limit} utilizados en este período (reinicia ${i?.date})`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`本期已使用 ${i?.used} 中的 ${i?.limit} 个积分（重置 ${i?.date}）。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`今期間に使用されたクレジットは${i?.used}（${i?.limit}のうち）です（${i?.date}をリセットします）。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`इस अवधि में उपयोग किए गए ${i?.limit} क्रेडिट में से ${i?.used} क्रेडिट (${i?.date} रीसेट करता है)`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.used} de ${i?.limit} créditos usados neste período (reinicia ${i?.date})`)
	return /** @type {LocalizedString} */ (`${i?.used} of ${i?.limit} credits used this period (resets ${i?.date})`)
});